import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/frontend_w3era/src/components/Pages/StrategicReviewPage.tsx");
